import type { BasketLastItem } from "@onestore/api/basket"
import type { BasketViewItem } from "@gatsby-plugin-basket/types"
import { get, isNumber } from "lodash"
import type { AddToCartSourceValue } from "~/store/basket/constants"
import type { BasketStateItem } from "~/store/basket/types"
import isEmpty from "./isEmpty"
import SessionStorage from "./storage/SessionStorage"

const SOURCE_KEY = "source"

export type SourceObject = {
  planId: number
  source: AddToCartSourceValue
}

export function isItemEnabled(item: BasketStateItem | BasketViewItem): boolean {
  return !isNumber(
    (item as BasketStateItem).disabled_reason ||
      (item as BasketViewItem).disabledReason
  )
}

export function setAddCartSource(
  planId: SourceObject["planId"],
  source: SourceObject["source"]
): void {
  SessionStorage.set(
    SOURCE_KEY,
    JSON.stringify({
      planId,
      source,
    })
  )
}

/**
 * Drops a source stashed by setAddCartSource. Call it when the add-to-cart
 * request fails — getAddCartSource only clears the key once an add_to_cart
 * event actually fires, so a failed add would otherwise leave the source
 * behind and misattribute the next add of the same plan.
 */
export function clearAddCartSource(): void {
  SessionStorage.remove(SOURCE_KEY)
}

export function getAddCartSource(
  products: BasketLastItem[]
): AddToCartSourceValue | null {
  const source = SessionStorage.get(SOURCE_KEY)

  if (isEmpty(source)) {
    return null
  }

  const sourceObject: SourceObject = JSON.parse(source)

  const searchedProducts = products.find((product) => {
    const productPlanId = get(product, "plan_id")

    return productPlanId === sourceObject.planId
  })

  SessionStorage.remove(SOURCE_KEY)

  return !isEmpty(searchedProducts) ? sourceObject.source : null
}
